export default __webpack_public_path__ + "6cd29297a732823337454ef600db7f7c.png";